// export default function secondsToString(seconds) {
//   var numyears = Math.floor(seconds / 31536000)
//   var numdays = Math.floor((seconds % 31536000) / 86400)
//   var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600)
//   var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60)
//   var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60
//   return (
//     (numyears ? numyears + ' years ' : '') +
//     (numdays ? numdays + ' days ' : '') +
//     (numhours ? numhours + ' hours ' : '') +
//     (numminutes ? numminutes + ' minutes ' : '') +
//     numseconds +
//     ' seconds'
//   )
// }

export default function toHHMMSS(sec_num) {
  // var sec_num = parseInt(this, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600)
  var minutes = Math.floor((sec_num - hours * 3600) / 60)
  var seconds = sec_num - hours * 3600 - minutes * 60

  if (hours < 10) {
    hours = '0' + hours
  }
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  return (
    (Math.floor(sec_num / 3600) ? hours + ':' : '') +
    (minutes ? minutes + ':' : '00:') +
    seconds
  )
}
